export default __webpack_public_path__ + "91f58eb1f03f57d83a7a6916d2ab460c.jpg";